
























































































































































































































import {
  Component,
  Vue,
  Prop
} from 'vue-property-decorator'
import {
  Getter
} from 'vuex-class'
import {
  SurveyInfo,
  TsUserDto,
  TsRateeUser,
  TsAbstractUser,
  TsNewUserForm,
  TsManagerUser,
  TsUserRole
} from '@/interfaces'
import TsService from '@/services/TsService'
import UsersRateeCard from '@/components/360/UsersRateeCard.vue'
import RaterRateeCard from '@/components/360/RaterRateeCard.vue'
import TsAddUserModal from '@/components/modals/TsAddUserModal.vue'
import PerformanceManagerCard from '@/components/360/PerformanceManagerCard.vue'
import AppFooter from '@/components/footer/AppFooter.vue'

  @Component({
    name: 'UserDashboardPage',
    components: {
      UsersRateeCard,
      RaterRateeCard,
      PerformanceManagerCard,
      TsAddUserModal,
      AppFooter
    }
  })
export default class UserDashboardPage extends Vue {
    @Prop({
      required: true
    })
    tsSurveyId!: number;

    @Getter('user/isAuthenticated')
    isAuthenticated!: boolean;

    @Getter('survey/getDisplayedBaseSurveyInfo')
    surveyInfo!: SurveyInfo;

    @Getter('ts/getUsers')
    tsUserInfo!: TsUserDto;

    @Getter('ts/getManager')
    tsManager!: TsAbstractUser;

    @Getter('ts/hasRoleRater')
    hasRoleRater!: boolean;

    @Getter('ts/hasRoleRatee')
    hasRoleRatee!: boolean;

    @Getter('ts/hasRoleManager')
    hasRoleManager!: boolean;
    isMobile: boolean = window.innerWidth < 767;
    modalWidth: string = window.innerWidth < 767 ? '600px' : '80%';
    myRatees: TsRateeUser[] = [];
    ratersRatees: TsRateeUser[] = [];
    orderBy: {
      text: string;number: number
    } | null = null;
    isShowCompleted = false;
    modalError: string = '';
    myPerformanceManager: TsManagerUser | null = null;
    rateeMobileNav: boolean = false;
    showFilters: boolean = !this.isMobile;
    layout: number = 2;

    async toggleRateeMobileNav () {
      this.rateeMobileNav = !this.rateeMobileNav
    }

    async created (): Promise < void > {
      if (!this.isAuthenticated) {
        await this.$router.push({
          name: 'notFound'
        })
      }

      await this.uploadRaterRatee()
      this.myRatees = await TsService.uploadUserRatee(this.tsSurveyId)

      await this.uploadMyPerformanceManager()
      window.addEventListener('resize', () => {
        this.isMobile = window.innerWidth < 767
        this.showFilters = !this.isMobile
        this.modalWidth = this.isMobile === true ? '80%' : '600px'
      })
    }

    get sortItemList (): any {
      return [{
        text: this.$t('sort.last_review_asc'),
        number: 1
      },
      {
        text: this.$t('sort.last_review_desc'),
        number: 2
      }
      ]
    }

    get filteredRaterRatees (): TsRateeUser[] {
      let result = this.ratersRatees

      if (this.isShowCompleted) {
        // todo::change filter for complete field
        result = result.filter((ratee: TsRateeUser) => ratee.id !== 2)
      }

      // todo::add ordering
      // switch (this.orderBy.number) {
      //   case 1:
      //     this.queryParameters['orderBy'] = 'lastReview'
      //     this.queryParameters['direction'] = 'asc'
      //     break
      //   case 2:
      //     this.queryParameters['orderBy'] = 'lastReview'
      //     this.queryParameters['direction'] = 'desc'
      //     break
      // }

      return result
    }
    get ratingHeader (): string {
      return this.hasRoleManager ? 'rating_teams' : 'who_i_rating'
    }

    changeLayout (layout: number): void {
      this.layout = layout
    }

    async uploadRaterRatee (): Promise < void > {
      if (this.hasRoleManager) {
        this.ratersRatees = await TsService.getRateeList(this.tsSurveyId)
      } else if (this.hasRoleRater) {
        this.ratersRatees = await TsService.uploadRatersRatee(this.tsSurveyId)
      }
    }

    viewScore (ratee: TsRateeUser) {
      this.$router.push({
        name: 'survey.ts.user.results',
        params: {
          tsSurveyId: this.tsSurveyId.toString(),
          tsRaterRateeId: ratee.id.toString()
        }
      })
    }

    async uploadMyPerformanceManager () {
      if (this.hasRoleRatee) {
        if (!this.myRatees.length) {
          return
        }

        this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATEE, this.myRatees[0].id)
      } else if (this.hasRoleRater) {
        if (!this.ratersRatees.length) {
          return
        }

        this.myPerformanceManager = await TsService.getManagerInfo(TsUserRole.RATER, this.ratersRatees[0].id)
      }
    }

    addNewRatee () {
      this.$modal.show('new-ratee-modal')
    }

    handleCancelModal () {
      this.modalError = ''
      this.$modal.hide('new-ratee-modal')
    }

    handleChangedModal () {
      this.modalError = ''
    }

    async handleConfirmModal (user: TsNewUserForm) {
      try {
        const newRatee = await TsService.addRatee(
          this.tsSurveyId,
          this.tsManager.id,
          user
        )
        this.$modal.hide('new-ratee-modal')

        this.ratersRatees.push(newRatee)
      } catch (error) {
        if (
          'response' in error && [400, 403, 404].includes(error.response.status)
        ) {
          const {
            detail
          } = error.response.data

          this.modalError = detail
        } else {
          throw error
        }
      }
    }
}

